import { render, staticRenderFns } from "./promotion-poster.vue?vue&type=template&id=5ba0eca9&scoped=true&"
import script from "./promotion-poster.vue?vue&type=script&lang=js&"
export * from "./promotion-poster.vue?vue&type=script&lang=js&"
import style0 from "./promotion-poster.vue?vue&type=style&index=0&id=5ba0eca9&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba0eca9",
  null
  
)

export default component.exports